<template>
  <div class="media-box">
    <div class="media-item">
      <i
        class="el-icon-wei2"
        @click="handleShowWechat" />
      <div class="media-name">{{ t('footer.WeChatofficial') }}</div>
    </div>
    <div class="media-item">
      <i
        class="el-icon-applet"
        @click="handleShowMini" />
      <div class="media-name">{{ t('footer.WeChat_applet') }}</div>
    </div>
    <ClientOnly>
      <el-dialog
        v-model="dialogVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :title="dialogTitle"
        append-to-body
        class="preview-component"
        destroy-on-close
        width="400px">
        <img
          :alt="dialogTitle"
          :src="dialogImg"
          rel="nofollow,noindex" />
        <div class="desc">{{ t('footer.desc') }}</div>
      </el-dialog>
    </ClientOnly>
  </div>
</template>

<script lang="ts">
  import { defineComponent, ref } from 'vue'
  import { useI18n } from 'vue-i18n'

  export default defineComponent({
    setup() {
      const { t } = useI18n()
      const dialogVisible = ref(false)
      const dialogTitle = ref('')
      const dialogImg = ref('')

      const handleShowWechat = async () => {
        dialogVisible.value = true
        dialogTitle.value = t('footer.scan_follow') as string // Use a proper translation method in your context
        dialogImg.value = (await import('~/assets/images/juzhan-gh.jpg')).default
      }

      const handleShowMini = async () => {
        dialogVisible.value = true
        dialogTitle.value = t('footer.scan_openApplet') as string // Use a proper translation method in your context
        dialogImg.value = (await import('~/assets/images/juzhan-mini.jpg')).default
      }

      return {
        t,
        dialogVisible,
        dialogTitle,
        dialogImg,
        handleShowWechat,
        handleShowMini
      }
    }
  })
</script>

<style lang="less" scoped>
  .media-box {
    display: flex;
    gap: 16px;

    .media-item {
      display: flex;
      gap: 8px;
      flex-direction: column;
      align-items: center;

      .media-name {
        font-size: 12px;
        color: #999;
        white-space: nowrap;
      }
    }

    i {
      width: 32px;
      overflow: hidden;
      border-radius: 50%;
      margin-left: 14px;
      cursor: pointer;

      &:first-child {
        margin-left: 0;
      }

      &::before {
        font-size: 32px !important;
      }
    }
  }
</style>

<style lang="less">
  .preview-component {
    .el-dialog {
      border-radius: 8px;
    }

    .el-dialog__close {
      font-size: 22px;
    }

    .el-dialog__body {
      padding: 32px 0 54px !important;
      text-align: center;
    }

    img {
      width: 220px;
    }

    .desc {
      font-size: 14px;
      color: #333;
      text-align: center;
      margin-top: 32px;
    }
  }
</style>
